import React from 'react';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid/v4';

import {
  Display,
  Header,
  Content,
  Footer,
  HardwareButtonWrapper,
  Labels,
  Label
} from 'containers';

import { HeaderText } from 'components';
import { DisplayButton } from 'components/buttons';

const Alarms = ({
  id,
  content,
  startScreen,
  selected,
  changeState,
  updateItem
}) => {
  const { screens, routes } = content;
  const alarms = content.list;

  const enterAlarms = () => changeState(id, 0);

  const changeSelection = () => {
    let currentItem = selected + 1;
    let startScreenNext = false;

    if (currentItem >= alarms.length) {
      startScreenNext = true;
      currentItem = null;
    }

    changeState(id, currentItem, startScreenNext);
  };

  const toggleAlarm = () => {
    const alarm = { ...alarms[selected] };

    alarm.active = !alarm.active;

    updateItem(id, alarm);
  };

  const showAlarms = () => {
    const perPage = 3;
    const currentPage = Math.floor((selected + perPage) / perPage);
    const start = (currentPage - 1) * perPage;
    const end = currentPage * perPage;

    return alarms.slice(start, end).map((alarm, i) => (
      <Label
        key={uuidv4()}
        name={alarm.name}
        invert={alarm.active}
        focused={selected === (start + i)}
      />));
  };

  const screensButtonConfig = {
    start: {
      left: {
        destination: routes.left
      },
      center: {
        onClick: enterAlarms
      },
      right: {
        destination: routes.right
      }
    },
    alarm: {
      center: {
        onClick: changeSelection
      },
      right: {
        onClick: toggleAlarm
      }
    }
  };

  const [entryScreen] = screens;
  const config = (startScreen) ? 'start' : 'alarm';
  const buttonConfig = screensButtonConfig[config];

  return [
    <Display key="display">
      <Header>
        <HeaderText value={entryScreen.title} />
      </Header>
      <Content>
        {startScreen ?
          <Labels values={entryScreen.data} />
        :
          showAlarms()
        }
      </Content>
      <Footer align={!startScreen ? 'right' : ''}>
        {startScreen && <DisplayButton src="icon-xm-left-arrow" />}
        <DisplayButton src={`icon-xm-${startScreen ? 'enter' : 'cycle'}`} />
        <DisplayButton src={`icon-xm-${startScreen ? 'right-arrow' : 'enter'}`} />
      </Footer>
    </Display>,
    <HardwareButtonWrapper key="buttons" config={buttonConfig} />
  ];
};

Alarms.defaultProps = {
  selected: null
};

Alarms.propTypes = {
  content: PropTypes.shape({
    screens: PropTypes.arrayOf(PropTypes.object).isRequired,
    list: PropTypes.arrayOf(PropTypes.object).isRequired,
    routes: PropTypes.objectOf(PropTypes.string).isRequired
  }).isRequired,
  id: PropTypes.string.isRequired,
  startScreen: PropTypes.bool.isRequired,
  selected: PropTypes.number,
  updateItem: PropTypes.func.isRequired,
  changeState: PropTypes.func.isRequired
};

export default Alarms;



// WEBPACK FOOTER //
// ./src/screens/shared/Settings/Alarms/Alarms.js